import { Config } from 'final-form'

import AtestadoModel from '../components/model-atestado'

export const MESSAGE_TOOLTIP_SUBMIT_ATESTADO_DISABLED =
  'É necessário cadastrar um e-mail para gerar um atestado digital.'

export type AtestadoOnSubmitCallback = Config<AtestadoModel>['onSubmit']
